<script>
import OrderQuantityControl from './order_quantity_control.vue';

export default {
  components: {
    OrderQuantityControl
  }
};
</script>

<template>
  <order-quantity-control
    name="transaction[quantity]"
  />
</template>
